import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=664b6d9b&scoped=true"
import script from "./assess.vue?vue&type=script&lang=ts"
export * from "./assess.vue?vue&type=script&lang=ts"
import style0 from "./assess.vue?vue&type=style&index=0&id=664b6d9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b6d9b",
  null
  
)

export default component.exports